/**
 * Auth route – thin client wrapper so auth content never runs on server.
 * Prevents SSR "cachedShadowRoot" 500 on dev (GET /auth, HEAD /auth).
 * Real content loads client-only via dynamic(AuthPageClient, { ssr: false }).
 */

'use client';

import dynamic from 'next/dynamic';

function AuthPageLoadingShell() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-2 border-neutral-200 border-t-neutral-600" />
    </div>
  );
}

const AuthPageClient = dynamic(
  () => import('./AuthPageClient').then((m) => m.default),
  { ssr: false, loading: AuthPageLoadingShell }
);

export default function AuthPage() {
  return <AuthPageClient />;
}
